import { fetchApi, getFetchApiJSONResponse } from 'shared/functions';

export const fetchESGDocuments = () =>
  fetchApi('/esg/api/methodology-list/').then(getFetchApiJSONResponse);

export const fetchESGAdditionalDocuments = () =>
  fetchApi('/esg/api/additional-documents-list/').then(getFetchApiJSONResponse);
